var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "features" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("settings.talkSettings"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v(_vm._s(_vm.$t("settings.talkSubtitles"))),
      ]),
    ]),
    _vm._v(" "),
    _c("section", [
      _c(
        "div",
        { staticClass: "features" },
        _vm._l(_vm.features, function (feature) {
          return _c("FeatureItem", {
            key: feature.id,
            attrs: {
              title: feature.title,
              description: feature.description,
              value: _vm.readValue(feature.id),
              icon: feature.icon,
            },
            on: {
              input: function ($event) {
                return _vm.setValue(feature.id, $event)
              },
            },
          })
        }),
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }